import React, { memo, useMemo, useCallback, useState } from "react";
import { withRedux, WithReduxHocPropsType } from "@al/next/al-ex";
import { Swiper, WebpImage } from "@al/akui-mobile";

import { tracker } from "~/common/tracker";

import { getTrackerSaReportInfo } from "../../../sensor-config";
import BigImg from "../../../common/components/BigImg";

import styles from "./styles.scss";

interface Props extends WithReduxHocPropsType {
  images: string[];
  topLeftAtmosIcon: string | null;
}

// TODO: 图片放大
const ProductImage: React.FC<Props> = (props) => {
  const [current, setCurrent] = useState(0);
  const [bigImgVisible, setBigImgVisible] = useState(false);

  if (!props?.images || props?.images.length === 0) {
    return <div className={styles.product_image} />;
  }

  const dots = useCallback((): null => null, []);
  // 点击图片 查看大图
  const handleClickImg = useCallback((): void => {
    setBigImgVisible(true);
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickBrand" }),
    });
  }, []);
  const handleCloseBigImg = useCallback(() => setBigImgVisible(false), []);
  const dataSource = useMemo(() => props?.images?.map((image, i) => ({ image, id: image + "" + i })), [props?.images]);

  const images = useMemo((): React.ReactElement[] => {
    return (
      props.images?.map((item, i) => (
        <Swiper.Item className={styles.swiper_item} key={item + i} onClick={handleClickImg}>
          <WebpImage className={styles.image} source={item} width={360} />
        </Swiper.Item>
      )) ?? []
    );
  }, [props.images, handleClickImg]);

  const handleIndexChange = (index: number): void => {
    setCurrent(index);
    tracker.click({
      sa: getTrackerSaReportInfo({ page: "homePage", eventName: "clickCarousel" }),
    });
  };

  return (
    <div className={styles.product_image}>
      {/* 图片轮播集合 */}
      <Swiper className={styles.swiper} onIndexChange={handleIndexChange} loop indicator={dots}>
        {images}
      </Swiper>

      {/* 数量指示器 */}
      {images.length > 1 ? (
        <span className={styles.count}>
          <span className={styles.count_current}>{current + 1}</span>
          <span className={styles.count_total}>/{images.length}</span>
        </span>
      ) : null}

      {/* 左上角氛围图 */}
      {props.topLeftAtmosIcon ? (
        <WebpImage className={styles.top_left_icon} source={props.topLeftAtmosIcon} width={120} />
      ) : null}

      {/* 预览大图 */}
      <BigImg defaultIndex={current} dataSource={dataSource} closeModal={handleCloseBigImg} visible={bigImgVisible} />
    </div>
  );
};

export default withRedux((state) => ({ topLeftAtmosIcon: state.static.skuPrice?.promotion?.topLeftAtmosIcon }))(
  memo(ProductImage)
);
